module.exports = __webpack_public_path__ + "static/media/ic-quality.fdddfdf8.svg";